<template>
  <div class="headTop">
    <router-link class="logoDiv flex-start" to="login">
      <img src="@/assets/image/logo2.png" alt="" class="logo"/>
      <span>银行联合收单营销平台</span>
    </router-link>
    <div class="tabMenu contentWidth">
      <span><router-link to="login" :class="{'active': $route.name === 'login'}">首页</router-link></span>
      <span><router-link to="resolve" :class="{'active': $route.name === 'resolve'}">解决方案</router-link></span>
      <span><router-link to="introduction" :class="{'active': $route.name === 'introduction'}">业务介绍</router-link></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'headTop',
  data () {
    return {
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="less">
.headTop{
  position: relative;
  box-sizing: border-box;
  width: 100%;
  background: #fff;
  height: 80px;
  line-height: 80px;
  .logoDiv{
    position: absolute;
    left: 35px;
    img{
      width: 67px;
      display: inline-block;
    }
    span{
      color: #000;
      font-size: 20px;
      margin-left: 20px;
    }
  }
  .tabMenu{
    text-align: right;
    span{
      &:last-child{
        a{
          margin-right: 0;
        }
      }
    }
    a{
      font-size: 16px;
      height: 80px;
      box-sizing: border-box;
      line-height: 80px;
      display: inline-block;
      margin-right: 80px;
      color: #4C4C4C;
      &:hover{
        color: var(--main-color)
      }
      &.active{
        color: var(--main-color);
        border-bottom: solid 4px var(--main-color);
      }
    }
  }
}
</style>
